import React from 'react';

// Utils
import { MESSAGES } from '~/utils/message';

// Components
import CreateTestOrderConfirmModal from '../CreateTestOrderConfirmModal';
import OlcButton from '~/components/General/OlcButton';
import EmptyStateCard from '~/components/General/EmptyStateCard';

// Icons
import { NoOrdersScreenCIcon } from '~/assets/images';

const NoOrdersScreen = ({
  handleCreateOrder,
  openCreateConfirm,
  setOpenCreateConfirm,
  confirmCreateOrder,
}) => {
  return (
    <>
      <div className="olcEmptyStateToolbar">
        <OlcButton variant="primary" size="small" onClick={handleCreateOrder}>
          {MESSAGES.ORDERS.NO_ORDERS_SCREEN.CREATE_ORDER_BUTTON}
        </OlcButton>
      </div>
      <EmptyStateCard
        icon={NoOrdersScreenCIcon}
        iconAlt="no-orders"
        title={MESSAGES.ORDERS.NO_ORDERS_SCREEN.TITLE_NEW}
        description={MESSAGES.ORDERS.NO_ORDERS_SCREEN.DESCRIPTION}
      />
      <CreateTestOrderConfirmModal
        open={openCreateConfirm}
        onClose={() => setOpenCreateConfirm(false)}
        onConfirm={confirmCreateOrder}
      />
    </>
  );
};

export default NoOrdersScreen;
